import type { ModuleManifest } from '../types.js'

/**
 * Хүний нөөц — cloud.maximus.mn-ий `employees_*` өгөгдлөөс хуулсан бүртгэл.
 *
 * Одоогийн хамрах хүрээ: ажилтны жагсаалт, дэлгэрэнгүй, хэлтэс/албан тушаал/
 * байршлын лавлахууд. Ирц, чөлөө, ажилд авалт, community зэрэг эх системийн
 * бусад хэсэг энэ манифест дээр нэмэгдэнэ.
 *
 * Өгөгдөл `pnpm --filter api hr:import` -ээр АНХ УДАА татагдана.
 *
 * ! Импорт нь зорилтот хүснэгтүүдийг TRUNCATE хийдэг тул ашиглалтад орсны дараа
 * ! дахин дуудвал панелаас хийсэн бүх засвар устана. Засах боломж нэмэгдсэнээс
 * ! хойш энэ бааз нь эх сурвалжийн хуулбар биш, ӨӨРИЙН ЭЗЭМШИЛ.
 *
 * `create` / `delete` эрх зарлаагүй: ажилтныг үүсгэх, устгах нь эх системд
 * хэвээр байгаа бөгөөд хоёр талаас зэрэг үүсгэвэл id мөргөлдөнө.
 */
export const hrModule = {
  key: 'hr',
  name: 'Хүний нөөц',
  description: 'Ажилтны бүртгэл, хэлтэс, албан тушаал, ажлын байршил.',
  version: '1.0.0',
  icon: 'BriefcaseBusinessIcon',

  permissions: [
    { resource: 'hr.employees', action: 'list', description: 'Ажилтнууд жагсаах' },
    { resource: 'hr.employees', action: 'show', description: 'Ажилтны дэлгэрэнгүй харах' },
    { resource: 'hr.employees', action: 'edit', description: 'Ажилтны мэдээлэл засах' },

    /*
     * ! Ажилтан ҮҮСГЭХ нь `edit`-ЭЭС ТУСДАА эрх. Байгаа ажилтны утас засах нь
     * ! шинэ хүнийг цалингийн жагсаалтад оруулахтай ижил жинтэй биш.
     *
     * Одоогоор зөвхөн ажилд авах дамжлагаас ашиглагдана — гараар ажилтан
     * нэмэх дэлгэц байхгүй (ажилтан импортоор ирдэг).
     */
    { resource: 'hr.employees', action: 'create', description: 'Ажилтан үүсгэх (ажилд авах)' },

    /*
     * ! Ү8 (docs/31 §4u, D8-9): МӨНГӨ НЭЭХ ХҮРЭЭ ХУВААРИЛАХ — ажилтанд «Борлуулалтын суваг» (`sales_channel`) лавлах
     * ! нэмэх/хасах. Энэ нь ЭРХ ОЛГОЛТ (BI Менежер түвшинд тухайн сувгийн мөнгө нээгдэнэ) тул `hr.employees:edit`-ээс ТУСДАА:
     * ! seed-ийн `manager` дүр `users:edit` + `hr.employees:edit` хоёуланг эзэмшдэг. ӨӨРТӨӨ хуваарилахыг ХОРИГЛОНО (хэн ч).
     * ! `admin`/`super-admin` seed-ээр; бизнест мөнгөний хандалтыг хариуцагчид л. PIN-ийн жагсаалтад ОРОХГҮЙ.
     */
    { resource: 'hr.employees', action: 'scope', description: 'Ажилтны мөнгө нээх хүрээ (борлуулалтын суваг) хуваарилах' },

    /*
     * ! 2026-09-27 (docs/08 §PIN-ээр бүрэн нэвтрэх): PIN = БҮРЭН итгэмжлэл (панелийн код + PIN нэвтрэлт жинхэнэ эрх өгнө).
     * ! Эрх мэдэлтэй (панелийн эрхтэй) хэрэглэгчийн PIN тавих, PIN-тэй ажилтанд эрхтэй хэрэглэгч холбох нь БҮРТГЭЛ
     * ! ЭЗЭМШИХ зам тул `hr.employees:edit`-ээс ТУСДАА. `admin`/`super-admin` seed-ээр; `manager`, `hr-manager`-т ӨГӨХГҮЙ.
     * ! Талбарын ажилтны PIN (эрхгүй бүртгэл) `edit`-ээр хэвээр. PIN-ийн (апп) жагсаалтад ОРОХГҮЙ.
     */
    { resource: 'hr.employees', action: 'credentials', description: 'Эрх мэдэлтэй хэрэглэгчийн PIN тохируулах, PIN-тэй ажилтанд холбох' },

    /*
     * НИЙТИЙН ЛАВЛАХ нь `hr.employees`-ээс ТУСДАА эрхтэй. Энгийн ажилтан хамт
     * олноо олох ёстой ч ХН-ийн бүрэн бүртгэл рүү орох ёсгүй — нэг эрхээр
     * хоёуланг өгвөл яг тэр зөрчил үүснэ. API нь ч тусдаа талбарын багц буцаана.
     */
    { resource: 'hr.directory', action: 'list', description: 'Нийтийн ажилтны лавлах' },

    /*
     * ! АЖИЛТНЫ ЭРХ (`/hr/directory/settings`, эзний шийдвэр 2026-10-12) — ХУВИЙН ХЭРЭГГҮЙ удирдлагын дэлгэц.
     * ! Нэвтрэх төлөв (код, PIN), 1С-ийн лавлах ЛАВЛАХЫН ТАЛБАРЫН БАГЦААР (`/hr/access/*`, регистр, утас, гэр бүл ОГТ
     * ! ОРОХГҮЙ) — `hr.employees:*`-ээс ТУСДАА: тэр нь хувийн хэргийг бүхэлд нь нээдэг. Үйлдэгч ӨӨРИЙН байгууллагын
     * ! ажилтныг л хардаг (`users.employee_id` → `hr_employees.organization_id`); `hr.employees:edit` / `super-admin`
     * ! байгууллагаар хязгаарлагдахгүй. ӨӨРИЙН мөрөнд бичихгүй (403).
     * !   `manage` — PIN шинэчлэх (эрх мэдэлтэй хэрэглэгчийнх `hr.employees:credentials`-ээр л), 1С лавлах засах;
     * !   `create` — код олгох нь `hr.employees:create`-тэй адил БУЦААХГҮЙ тул тусдаа;
     * !   `scope`  — «Борлуулалтын суваг» BI-д мөнгө нээнэ (`hr.employees:scope`-тэй ижил жин) тул тусдаа.
     * ! Бүгд панелийн эрх — аппын (`sid`) жагсаалтад ОРОХГҮЙ ([[account-policy]]).
     */
    { resource: 'hr.access', action: 'list', description: 'Ажилтны эрх — жагсаалт (нэвтрэх төлөв, 1С лавлах)' },
    { resource: 'hr.access', action: 'manage', description: 'PIN шинэчлэх, 1С лавлах засах (суваг бусад)' },
    { resource: 'hr.access', action: 'create', description: 'Нэвтрэх код олгох — буцаахгүй' },
    /*
     * ! `scope` нь ЗӨВХӨН байгууллагаар хилтэй үйлдэгчид хүчинтэй. Хилгүй (`hr.employees:edit` / супер админ) нь
     * ! ХН-ийн замтай ИЖИЛ `hr.employees:scope` шаардана (API `scopePermissionsFor`, админ `hrAccessCapabilities`).
     */
    { resource: 'hr.access', action: 'scope', description: 'Борлуулалтын суваг (BI мөнгө) олгох — өөрийн байгууллагад' },

    /*
     * ӨӨРИЙН бүртгэл. Эрх нь бүх дүрд олгогдоно — хүн өөрийнхөө мэдээллийг
     * харах нь эрхийн асуудал биш.
     *
     * ! Гэсэн ч эрх ЗАРЛАХ ёстой: `@RequirePermissions` байхгүй маршрут нь
     * ! зөвхөн «нэвтэрсэн эсэх»-ээр шалгагдаж, модуль унтраахад ХААГДАХГҮЙ.
     */
    { resource: 'hr.self', action: 'show', description: 'Миний профайл' },

    /*
     * ! ЗӨВХӨН ЗУРАГ. Ажилтан өөрийн профайлын зургийг мобайл аппаас солино;
     * ! утас, яаралтай холбоо, регистр зэрэг нь ХН-ийн бүртгэл тул энд
     * ! ОРОХГҮЙ — тэдгээрийг засах цэгийг үүн дор нэмж БОЛОХГҮЙ.
     */
    { resource: 'hr.self', action: 'edit', description: 'Миний профайлын зураг солих' },

    /*
     * АЖИЛД АВАХ. Хоёр эрхээр хангалттай — жагсаах ба удирдах. Зар, анкет,
     * шат, тэмдэглэл тус бүрд эрх зарлавал матриц 12 мөрөөр уртсах ба
     * тэдгээр нь бодит байдал дээр хамт олгогддог.
     *
     * ! Анкетад РЕГИСТР, төрсөн огноо, цалингийн хүлээлт байдаг тул
     * ! `hr.employees:list`-ээс тусад нь зарлав: зар харах хүн бүр нэр
     * ! дэвшигчийн хувийн мэдээллийг харах ёсгүй.
     */
    { resource: 'hr.recruitment', action: 'list', description: 'Ажлын байрны зар, анкет харах' },

    /*
     * ! `list`-ЭЭС ТУСДАА. `list` нь АНКЕТЫН регистрийг нээдэг (нэр дэвшигчийн
     * ! хувийн мэдээлэл); `open` нь зөвхөн НИЙТЭД зарлагдсан ажлын байрыг
     * ! харуулна. Ажилтан бүрд `list` өгвөл анкет задарна.
     */
    { resource: 'hr.recruitment', action: 'open', description: 'Нээлттэй ажлын байр харах' },
    { resource: 'hr.recruitment', action: 'manage', description: 'Зар үүсгэх, анкетын шат солих' },

    /*
     * ЛАВЛАГААНУУД — түвшин, ангилал, эрхлэлтийн төрөл, хэлтэс, албан тушаал…
     *
     * Нэг хос эрх бүх лавлахыг хамарна. Лавлах тус бүрд эрх зарлавал эрхийн
     * матриц 16 мөрөөр уртсах ба тэдгээр нь бодит байдал дээр хамт олгогддог —
     * хүний нөөцийн тохиргоог хийдэг хүн бүгдийг нь хийдэг.
     */
    { resource: 'hr.lookups', action: 'list', description: 'ХН-ийн лавлагаа харах' },
    { resource: 'hr.lookups', action: 'manage', description: 'ХН-ийн лавлагаа удирдах' },
  ],

  navigation: [
    {
      label: 'Хүний нөөц',
      items: [
        {
          label: 'Хяналтын самбар',
          href: '/hr/dashboard',
          icon: 'LayoutDashboardIcon',
          iconClassName: 'text-indigo-600 dark:text-indigo-400',
          permission: 'hr.employees:list',
        },
        {
          label: 'Ажилтнууд',
          href: '/hr/employees',
          icon: 'UsersRoundIcon',
          iconClassName: 'text-sky-600 dark:text-sky-400',
          permission: 'hr.employees:list',
        },
        {
          /*
           * Идэвхгүй мөрүүд «Ажилтнууд» жагсаалтад ГАРАХГҮЙ (тэнд `isActive`
           * шүүлт үндсэн утгаараа идэвхтэйг л үзүүлнэ) тул тусдаа цэг хэрэгтэй.
           * Эрх нь ижил — гарсан ажилтныг харах нь тусдаа нууцлалын түвшин биш.
           *
           * ! «Шилжсэн» таб нь ИДЭВХТЭЙ ажилтан үзүүлнэ: байгууллага хооронд
           * ! шилжсэн хүн бүлэгт үлддэг. Энэ дэлгэц «гарсан» гэж нэрлэгддэг ч
           * ! үнэндээ ХӨДӨЛГӨӨНИЙ бүртгэл ([[docs/39 §6]]).
           */
          label: 'Гарсан, чөлөөтэй, шилжсэн',
          href: '/hr/employees/inactive',
          icon: 'UserRoundXIcon',
          iconClassName: 'text-amber-600 dark:text-amber-400',
          permission: 'hr.employees:list',
        },
        {
          /*
           * ХҮЛЭЭН АВАХ САН — байгууллага хооронд шилжиж ирсэн, хараахан
           * хэлтэс, албан тушаал аваагүй хүмүүс.
           *
           * ! ТУСДАА ЦЭГ БАЙХ ЁСТОЙ. Эдгээр хүн ХЭЛТЭСГҮЙ тул «Ажилтнууд»
           * ! жагсаалтын хэлтсийн шүүлтэд ОГТ гарахгүй — хаа нэгтээ нуугдвал
           * ! хэн ч тэднийг хуваарилахгүй бөгөөд тэр хугацаанд ирц, чөлөөний
           * ! тайлангууд нь цоорхойтой гарна ([[docs/39 §6.2]]).
           */
          label: 'Хуваарилалт хүлээж буй',
          href: '/hr/employees/incoming',
          icon: 'InboxIcon',
          iconClassName: 'text-teal-600 dark:text-teal-400',
          permission: 'hr.employees:list',
        },
        {
          label: 'Ажилтны лавлах',
          href: '/hr/directory',
          icon: 'ContactRoundIcon',
          iconClassName: 'text-emerald-600 dark:text-emerald-400',
          permission: 'hr.directory:list',
        },
        {
          /*
           * ! Лавлахын ДОРХ зам (`/hr/directory/settings`) — ХН-ийн бус менежерт (`hr-access` дүр) «Ажилтны лавлах»-ын
           * ! хажууд харагдана. Дэлгэц нь `/hr/access/*`-ийг л дуудна, `/hr/employees/*`-ийг ХЭЗЭЭ Ч биш.
           */
          label: 'Ажилтны эрх',
          href: '/hr/directory/settings',
          icon: 'UserCogIcon',
          iconClassName: 'text-cyan-600 dark:text-cyan-400',
          permission: 'hr.access:list',
        },
        {
          label: 'Миний булан',
          href: '/me',
          icon: 'CircleUserRoundIcon',
          iconClassName: 'text-violet-600 dark:text-violet-400',
          permission: 'hr.self:show',
        },
        {
          label: 'Ажилд авах',
          icon: 'UserPlusIcon',
          iconClassName: 'text-rose-600 dark:text-rose-400',
          permission: 'hr.recruitment:list',
          children: [
            { label: 'Ажлын байрны зар', href: '/hr/recruitment/postings' },
            { label: 'Анкетууд', href: '/hr/recruitment/applications' },
          ],
        },
        {
          label: 'Байгууллагын бүтэц',
          href: '/hr/organization',
          icon: 'NetworkIcon',
          iconClassName: 'text-emerald-600 dark:text-emerald-400',
          permission: 'hr.employees:list',
        },
        {
          label: 'Лавлагаа',
          icon: 'SettingsIcon',
          iconClassName: 'text-slate-600 dark:text-slate-400',
          permission: 'hr.lookups:list',
          children: [
            { label: 'Ажилтны түвшин', href: '/hr/lookups/employee-levels' },
            { label: 'Ажилтны ангилал', href: '/hr/lookups/employee-categories' },
            { label: 'Хөдөлмөр эрхлэлтийн төрөл', href: '/hr/lookups/employment-types' },
            { label: 'Ажлаас гарах шалтгаан', href: '/hr/lookups/departure-reasons' },
            { label: 'Ур чадварын төрөл', href: '/hr/lookups/skill-types' },
            { label: 'Ур чадвар', href: '/hr/lookups/skills' },
            { label: 'Чадварын түвшин', href: '/hr/lookups/skill-levels' },
            { label: 'Хэлтэс', href: '/hr/lookups/departments' },
            { label: 'Албан тушаал', href: '/hr/lookups/job-positions' },
            { label: 'Үндсэн ажлын байршил', href: '/hr/lookups/work-locations' },
            { label: 'Ажлын цагийн хуваарь', href: '/hr/lookups/work-schedules' },
          ],
        },
      ],
    },
  ],

  resources: [
    {
      name: 'hr.job-postings',
      label: 'Ажлын байрны зар',
      list: '/hr/recruitment/postings',
      canDelete: true,
    },
    {
      name: 'hr.applications',
      label: 'Анкетууд',
      list: '/hr/recruitment/applications',

      /*
       * ! ДЭЛГЭРЭНГҮЙ ЗАМ — тасалбарын мөр (breadcrumb) ба «нээх» холбоосууд
       * ! үүнээс уншина. Хажуугийн панел нь `?record=`-ээр ажилладаг ч тэр нь
       * ! ХУРДАН харагдац; бүтэн дэлгэц нь ажилтны `/hr/employees/:id`-тэй
       * ! ижил бүтэцтэй бөгөөд хэвлэх загвар ч түүнээс нээгдэнэ.
       */
      show: '/hr/recruitment/applications/:id',
      canDelete: false,
    },
    {
      name: 'hr.self',
      label: 'Миний булан',
      list: '/me',
      canDelete: false,
    },
    {
      name: 'hr.directory',
      label: 'Ажилтны лавлах',
      list: '/hr/directory',
      canDelete: false,
    },
    {
      /*
       * ! `apiPath` — Refine-ийн жагсаалт/`getOne` нь `/hr/access/employees(/:id)` руу очно (нэрээс гарах `hr/access`
       * ! гэсэн цэг БАЙХГҮЙ). Бичилт нь `useCustomMutation`-аар (`/pin`, `/employee-code`, `/references`).
       */
      name: 'hr.access',
      label: 'Ажилтны эрх',
      apiPath: 'hr/access/employees',
      list: '/hr/directory/settings',
      canDelete: false,
    },
    {
      name: 'hr.employees',
      label: 'Ажилтнууд',
      list: '/hr/employees',
      show: '/hr/employees/:id',

      /*
       * ! `/edit` НЬ ДЭЛГЭРЭНГҮЙН «МАЯГТЫН ГОРИМ», ТУСДАА МАЯГТ БИШ.
       *
       * ! Урьд нь `/hr/employees/:id/edit` гэсэн бүтэн маягт байсан бөгөөд
       * ! тэр нь дэлгэрэнгүй дэлгэцээс ШАЛ ӨӨР харагддаг байв — нэг ажилтны
       * ! хоёр төрх. Түүнээс ч ноцтой нь: тэр маягт ажилтны КОДЫГ чөлөөтэй
       * ! өөрчлөх боломж өгдөг байсан (ирц, ZKTeco, цалин бүгд түүн дээр
       * ! тогтдог). 2026-09-22-нд хаагдаж, дэлгэрэнгүй рүү чиглүүлдэг болов.
       * !
       * ! 2026-09-25-нд БУЦААЖ НЭЭВ — харин ӨӨР ЗАРЧМААР: `/edit` нь яг ижил
       * ! `EmployeeDetailView`-ийг `mode='edit'`-ээр зурна (толгой, хажуу самбар,
       * ! таб, талбарын дараалал ижил), шалгалт нь мөрөн дээрх засвартай НЭГ
       * ! `employeeFieldRules`, илгээлт нь ЗӨВХӨН өөрчлөгдсөн түлхүүртэй ганц
       * ! PATCH. Код хөлдүү байдлыг СЕРВЕР барина: `PATCH /hr/employees/:id`
       * ! нь `employeeCode`-ыг 400-аар татгалзаж, кодгүй ажилтанд код олгох
       * ! цорын ганц зам нь `POST /hr/employees/:id/employee-code`.
       * ! Мөрөн дээрх засвар дэлгэрэнгүй дээр хэвээр ([[30-hr-employee-code]]).
       */
      edit: '/hr/employees/:id/edit',
    },

    /*
     * Лавлахууд нь Refine-ийн CRUD-ыг ШУУД ашиглана (`useTable` / `useCreate` /
     * `useUpdate` / `useDelete`) — нэрийн цэгийг data provider API зам болгож
     * хөрвүүлдэг (`resourceApiPath`).
     */
    {
      name: 'hr.employee-levels',
      label: 'Ажилтны түвшин',
      list: '/hr/lookups/employee-levels',
      canDelete: true,
    },
    {
      name: 'hr.employee-categories',
      label: 'Ажилтны ангилал',
      list: '/hr/lookups/employee-categories',
      canDelete: true,
    },
    {
      name: 'hr.employment-types',
      label: 'Хөдөлмөр эрхлэлтийн төрөл',
      list: '/hr/lookups/employment-types',
      canDelete: true,
    },
    {
      name: 'hr.departure-reasons',
      label: 'Ажлаас гарах шалтгаан',
      list: '/hr/lookups/departure-reasons',
      canDelete: true,
    },
    {
      name: 'hr.skill-types',
      label: 'Ур чадварын төрөл',
      list: '/hr/lookups/skill-types',
      canDelete: true,
    },
    { name: 'hr.skills', label: 'Ур чадвар', list: '/hr/lookups/skills', canDelete: true },
    {
      name: 'hr.skill-levels',
      label: 'Чадварын түвшин',
      list: '/hr/lookups/skill-levels',
      canDelete: true,
    },
    { name: 'hr.departments', label: 'Хэлтэс', list: '/hr/lookups/departments', canDelete: true },
    {
      name: 'hr.job-positions',
      label: 'Албан тушаал',
      list: '/hr/lookups/job-positions',
      canDelete: true,
    },
    {
      name: 'hr.work-locations',
      label: 'Үндсэн ажлын байршил',
      list: '/hr/lookups/work-locations',
      canDelete: true,
    },

    /*
     * ! АЖЛЫН ЦАГИЙН ХУВААРЬ (2026-09-29, docs/12 §Ажлын цагийн хуваарь) — `resourceApiPath` → `hr/work-schedules`.
     * ! Унших `hr.lookups:list`, харин БИЧИХ нь `timesheet.attendance:manage` (цалинд нөлөөлнө) — шинэ эрх ЗАРЛААГҮЙ,
     * ! хоёулаа аль хэдийн манифестад бий. Хуваарилалт (`/hr/work-schedule-assignments`) нь resource БИШ — дэлгэцүүд
     * ! `useCustom`-оор дууддаг.
     */
    {
      name: 'hr.work-schedules',
      label: 'Ажлын цагийн хуваарь',
      list: '/hr/lookups/work-schedules',
      canDelete: true,
    },
  ],
} as const satisfies ModuleManifest
